module.exports = __webpack_public_path__ + "static/media/write-icon.8ec3f13e.svg";